<template>
	<a class="dropdown-item py-2 px-0" href="#" @click="$bus.$emit('toggle-team-switcher')"><slot>Switch</slot></a>
</template>

<script>
export default {
  name: 'TeamSwitcherTrigger',
  data() {
    return {
    }
  },
}
</script>
